module.exports = __webpack_public_path__ + "img/dd1aca26f15561982a26c120048b3a65c6b507f1.7afaf15e.png";